var Allianz = (function (window, document) {
  function getBillingCountry(activePayment) {
    var Payments = FGTLibs.Payments;
    var PaymentType = Payments.PaymentType;
    var paypalCountryCode = $('#ppinfo-static').attr('data-countrycode');

    if (activePayment === PaymentType.PAYPAL) {
      return paypalCountryCode === 'US' ? 'United States' : paypalCountryCode;
    }

    return $('#billing_country').val();
  }

  function allowBillingState(activePayment) {
    var Payments = FGTLibs.Payments;
    var PaymentType = Payments.PaymentType;
    var paypalState = $('#ppinfo-static').attr('data-paypalstate');

    if (activePayment === PaymentType.PAYPAL && paypalState === 'PR') {
      return false;
    }

    return true;
  }

  function credentialsAllianz() {
    var credentials = {
      password: "",
      userName: ""
    }
    return credentials;
  };

  function customerAddressAllianz(activePayment) {
    var Payments = FGTLibs.Payments;
    var PaymentType = Payments.PaymentType;

    if (activePayment === PaymentType.PAYPAL) {
      return {
        city: $('#ppinfo-static').attr('data-paypalcity'),
        country: $('#ppinfo-static').attr('data-countrycode'),
        region: $('#ppinfo-static').attr('data-paypalstate'),
        postalCode: $('#ppinfo-static').attr('data-paypalzip')
      }
    }
  
    return {
      city: $('#billing_city').val(),
      country: 'US',
      region: $('#billing_select_state').val() ? $('#billing_select_state').val() : $('#contactBillingState').val(),
      postalCode: $('#billing_zip').val(),
    }
    
  };

  function customersPATCountAllianz(activePayment) {
    var Payments = FGTLibs.Payments;
    var PaymentType = Payments.PaymentType;
    var customers = [];
      customers.push({
        customerType: "PRIMARY",
        firstName: activePayment === PaymentType.PAYPAL ? $('#ppinfo-static').attr('data-paypalfirstname') : $('#billing_firstName').val(),
        sequence: 1
      });
    return customers;
  };


  function getEventDate(typeDate) {
    var timeZoneValue = $('#timeZone').val();

    var startDateVal = new Date($('#earlyDate').val().replace(/-/g, "/"));
    var endDateVal = new Date($('#lateDate').val().replace(/-/g, "/"));

    if(typeDate === "startDate") {
      var result = startDateVal;
      var currentDate = new Date();
      var currentDateString = new Date().toString();
      var currentDateArr = currentDateString.split(' ');
      if(currentDate.getTime() > startDateVal.getTime()) { 
        //if the start date of the event is on the past we need to format a current date for the insurance that will take the place of start date
        var startDateStr = startDateVal.toString();
        var timeStartDate = startDateStr.split(' ')[4];
        currentDateArr[4] = timeStartDate;
        var joincurrentDateArr = currentDateArr.join(' ');
        result = new Date(joincurrentDateArr);
      }
      //formting the Start date to Allianz format, removing the day of the week and adding a timezone

      return utilsPayloadCheckout.convertToISOFormat(result, timeZoneValue);
    }
    //formting the End date to Allianz format, removing the day of the week and adding a timezone

    return utilsPayloadCheckout.convertToISOFormat(endDateVal, timeZoneValue);
  }

  // Get the hours for the event
  function getNumberOfHours() {
    return $('#eventDuration').val();
  }


  function eventInfoAllianz() {

    /* Methods to obtain ISO time values for payload end*/

    var layawayfee = 0;

    if ($("#layaway_fee_span").length) {
      layawayfee = $("#layaway_fee_span").text();
      layawayfee = parseFloat(layawayfee.replace(/[$]/g, ''));
    };


    // events object, Part IV of payload
    var events = [{
      artistId: $('#artistId').val(),
      artistName: $('#artistName').val(),
      endDate: getEventDate("endDate"),
      eventName: window.location.origin + "/checkout/save_insurance",
      majorCategory: "MUSIC_EVENT",
      minorCategory: "OTHER",
      numberOfHours: getNumberOfHours(),
      sequence: 1,
      startDate: getEventDate("startDate"),
      totalCost: parseFloat($('#totalCost').val()) + layawayfee - $('#AllianzCost').val(),
      venue: {
        city: $('#Vcity').val(),
        country: "US",
        region: $('#Vregion').val()
      },
      venueCode: $('#venueCode').val(),
      venueName: $('#venueName').val(),
      venuePostalCode: $('#venuePostalCode').val()
    }];
    return events;
  };

  function requestDetailsAllianz() {

    var cstTime = utilsPayloadCheckout.getCstTime();

    var sessionlocal = localStorage.getItem("jStorage");
    var sessionlocalJSON = JSON.parse(sessionlocal);
    var sessionIdVal = sessionlocalJSON.jobId;



    var requestDetail = {
      businessUnit: "US",
      currency: $('#currency').val(),
      customerID: $('#customerID').val(),
      language: $('#language').val(),
      offerVersionId: 1,
      requestCategories: ["Event"],
      requestChannel: "Online",
      requestedDate: utilsPayloadCheckout.convertToISOFormat(cstTime, "America/Chicago"),
      requestOrigin: "Standard",
      sessionId: sessionIdVal,
      transactionId: $('#transactionId').val(),
    };
    return requestDetail;
  };

  function partnerAllianz() {
    var partner = {
      externalCode: "F211180"
    }
    return partner;
  };

  function getQuote(activePayment) {
    // context should be Checkout from checkout.js
    var Checkout = this;
    var payload = {
      credentials: credentialsAllianz(),
      customersAddress: customerAddressAllianz(activePayment),
      customers: customersPATCountAllianz(activePayment),
      events: eventInfoAllianz(),
      gadget: utilsDeviceInfo.getGadgetInfo(),
      partner: partnerAllianz(),
      requestDetail: requestDetailsAllianz()
    };

      //Enable allianz form
      $("#insurance_unavailable_when_venmo").addClass('hide');
      $("#allianzResponse").removeClass('hide');
      $("#allianzBtnNext").removeClass('hide');
    $.post(
      $("#labelRoot").val() + "/checkout/get_quote_from_allianz",
      { 'json': payload }
    )
      .done(function (result) {
        if (result.referenceId === 1) {
          $("#allianzResponseError").hide('hides');
          $("#allianzResponse").html(result.locations[0].output);

          //Display the paypal pay later message when user selects Paypal as MOP and pay later is enabled.
          if (($('#methodPayment').val() === 'Paypal') && $('#pay-later-button-container').length) {
            $("#paypalPayLaterMsg").removeClass('hide');
          }

          // Show and hide Next btn for insurance section
          $("#allianzBtnNext").removeClass('hide');

          $("#insuranceAllianzSelection").addClass('hide');

          // Get insurance value and add to html tag for twig file
          var protectTicket = JSON.parse($.cookie('allianz_quote'));
          var costAllianz = protectTicket.prices.totalPrice;
          var insuranceAllianzValue = costAllianz.toLocaleString("en-US", {style:"currency", currency:"USD"});
          $("#insuranceAllianzValueTag").text(insuranceAllianzValue);

          // Disabled Next btn for Allianz
          $("#btn-insurance-allianz-next").removeClass('hide');
          $("#btn-insurance-allianz-next").attr('disabled', 'disabled');
          $("#insurance_unavailable").addClass('hide');

          $('#btn-insurance-yes').on('click', function () {
            $("#btn-insurance-allianz-next").removeAttr('disabled');
            $("#btn-insurance-allianz-next").attr('value', 'Yes');
          })
          $('#btn-insurance-no').on('click', function () {
            $("#btn-insurance-allianz-next").removeAttr('disabled');
            $("#btn-insurance-allianz-next").attr('value', 'No');

          })
        }
        else {
          AllianzError.allianzNoresponse();
        }

        FG.Checkout.prototype.bindToSecureTicket();
        FG.Checkout.prototype.bindToInsuranceForm();

      })
      .fail(function (result) {
        AllianzError.allianzNoresponse();

        FG.Checkout.prototype.bindToSecureTicket();
        FG.Checkout.prototype.bindToInsuranceForm();

      });

  };

  // Continue process without allianz insurance
  function renderWithoutAllianz() {
    var Checkout = this;
    
    $("#insurance_unavailable_when_venmo").removeClass('hide');
    $("#insuranceAllianzSelection").addClass('hide');
    $("#insuranceAllianzDeclinedText").addClass('hide');
    $("#allianzResponse").addClass('hide');
    $("#allianzBtnNext").addClass('hide');
    $('#allianzResponse').append($('#form-error-allianz'));

    FG.Checkout.prototype.bindToSecureTicket();
    FG.Checkout.prototype.bindToInsuranceForm();
  }


  function doPurchaseRequestAllianz() {
    var cstTime = utilsPayloadCheckout.getCstTime();
    var layawayfee = 0;

    if ($("#layaway_fee_span").length) {
      layawayfee = $("#layaway_fee_span").text();
      layawayfee = parseFloat(layawayfee.replace(/[$]/g, ''));
    }

    var dateFormated = utilsPayloadCheckout.convertToISOFormat(cstTime, "America/Chicago");
    var cPAT = JSON.parse($.cookie('PATCount'));
    var protectTicket = JSON.parse($.cookie('allianz_quote'));
    var paymentMethod = $('#methodPayment').val();
    var cost = $('#totalCost').val() - $('#AllianzCost').val() + layawayfee;
    //check external y product y PAT

    var type;
    var nonceFake;
    var descriptor;
    var numberTickets;
    var billingAddressObj;
    var firstName;
    var lastName;
    if (cPAT < 1) {
      numberTickets = 1;
    } else {
      numberTickets = cPAT;
    }
    var booking = deriveBookingId(paymentMethod);

    if (paymentMethod === 'Paypal') {
      type = "PayPal";
      nonceFake = "";
      descriptor = "Event Ticket Purchase";
      street = $('#billing_address2').val() === "" ? $('#billing_address').val() : $('#billing_address').val() + ", " + $('#billing_address2').val();
      firstName = $('#ppinfo-static').attr('data-paypalfirstname') ? $('#ppinfo-static').attr('data-paypalfirstname') : $('#billing_firstName').val();
      lastName = $('#ppinfo-static').attr('data-paypallastname') ? $('#ppinfo-static').attr('data-paypallastname') : $('#billing_lastName').val();
      billingAddressObj = {
        Street: $('#ppinfo-static').attr('data-paypaladdress') ? $('#ppinfo-static').attr('data-paypaladdress') : street,
        City: $('#ppinfo-static').attr('data-paypalcity') ? $('#ppinfo-static').attr('data-paypalcity') : $('#billing_city').val(),
        Region: $('#ppinfo-static').attr('data-paypalstate') ? $('#ppinfo-static').attr('data-paypalstate') : $('#billing_select_state').val(),
        Country: "US",
        PostalCode: $('#ppinfo-static').attr('data-paypalzip') ? $('#ppinfo-static').attr('data-paypalzip') : $('#billing_zip').val(),
      };
    } else {
      type = "TK";
      nonceFake = "";
      billingAddressObj = {
        Street: $('#billing_address2').val() === "" ? $('#billing_address').val() : $('#billing_address').val() + ", " + $('#billing_address2').val(),
        City: $('#billing_city').val(),
        Region: $('#billing_select_state').val(),
        Country: "US",
        PostalCode: $('#billing_zip').val(),
      };
      firstName = $('#billing_firstName').val();
      lastName = $('#billing_lastName').val();
    }

    var PurchasesRequest = {
      Partner: {
        Password: "",
        UserID: ""
      },
      PurchasesRequest: {
        Accam: "F211180",
        BusinessUnit: "US",
        TransactionID: $('#transactionId').val(),
        Purchases: {
          Purchase: [{
            PartnerBookingID: booking,
            InsuranceBookingDetails: {
              PurchaseDateTime: dateFormated,
              Method: "Online",
              Status: "NEW",
              Type: "ADD",
              Currency: "USD",
              TotalCoverageAmount: cost,
              TotalPrice: null,
              TotalPremiumPrice: null,
              Purchaser: {
                FirstName: firstName,
                LastName: lastName,
                BillingAddress: billingAddressObj,
                EmailAddress: $('#confirm_email').val() ? $('#confirm_email').val() : $('#customerMail').val(),
                PhoneNumber: cleanPhoneNumber($('#billing_phone').val()),
              },
              FulfillmentMethod: "EMAIL",
              PaymentMethod: type,
              AFOP: {
                Payee: firstName + ' ' + lastName,
                CCN: $('#transactionId').val(),
                nonce: nonceFake,
                Descriptor: descriptor
              }
            },
            EventTicketBookingDetails: {
              Currency: "USD",
              TotalTicketCost: cost,
              Method: "Online",
              Path: "Event",
              DepositDate: dateFormated,
              Language: "en"
            },
            EventTicketDetails: {
              EventDate: getEventDate("startDate"),
              Location: {
                City: $('#Vcity').val(),
                Region: $('#Vregion').val(),
                Country: "US"
              }
            },
            ProductDetails: {
              Product: [{
                Sequence: "0",
                ProductID: null,
                QuoteID: null,
                InsuredDetails: {
                  Insured: [{
                    Sequence: "1",
                    Type: "PRIMARY",
                    FirstName: firstName,
                    LastName: lastName,
                    PhoneNumber: cleanPhoneNumber($('#billing_phone').val()),
                    EventTicketCost: cost,
                    NumberOfTickets: numberTickets
                  }]
                },
                CoverageAmount: cost,
                Price: null,
                PremiumPrice: null,
                StartDate: getEventDate("startDate"),
                EndDate: getEventDate("endDate")
              }]
            }
          }]
        }
      }
    };
    var payload = JSON.stringify(PurchasesRequest);
    if ($("#AllianzProv").val() === 'Allianz') {
      $.ajax({
        method: "POST",
        url: $("#labelRoot").val() + "/checkout/get_purchase_quote_from_allianz",
        data: {
          'json': PurchasesRequest,
          'client': $('#customerID').val(),
        },
        async: false
      }).done(function () {
        return true;
      });
    }
  };

  function cleanPhoneNumber(phoneNumber){
      return phoneNumber.replace(/[^\d]/g, ''); 
  }

  function doDecisionRequestAllianz() {
    var cstTime = utilsPayloadCheckout.getCstTime();
    var dateFormated = utilsPayloadCheckout.convertToISOFormat(cstTime, "America/Chicago");
    var protectTicket = JSON.parse($.cookie('allianz_quote'));
    var cost = $('#totalCost').val() - $('#AllianzCost').val();
    var paymentMethod = $('#methodPayment').val();

    var booking = deriveBookingId(paymentMethod);

    var DecisionRequest = {
      credentials: {
        userName: "",
        password: ""
      },
      bookingId: booking,
      businessUnit: "US",
      currencyType: "USD",
      cxid: null,
      responseId: null,
      responseType: "Purchased",
      details: [{
        responseType: "Declined",
        supplierCode: "AWP",
        productCode:null,
        purchasePrice: null,
        quantity: "1",
        responseQuoteId: null
      }],
      localTs: dateFormated
    };
    var payload = JSON.stringify(DecisionRequest);
    if ($("#AllianzProv").val() === 'Allianz') {
      $.ajax({
        method: "POST",
        url: $("#labelRoot").val() + "/checkout/get_decision_quote_from_allianz",
        data: { 'json': DecisionRequest },
        async: false
      }).done(function () {
        return true;
      });
    }
  };

  function promoAllianz(activePayment, currentStep, currentPaymentMethod) {
    var billingState = $('#contactBillingState').val();
    if(currentStep > 2){
      if($('#AllianzProv').val() === 'Allianz'){
        if(getBillingCountry(activePayment) === 'United States' && billingState !== 'PR') {
            if(currentPaymentMethod === 'Venmo'){
                FG.Checkout.prototype.makeStepActive('collapseThree');
                renderWithoutAllianz.call(self);
            }else if(currentPaymentMethod === 'GooglePay'){
                FG.Checkout.prototype.makeStepActive('collapseThree');
                $('#insuranceAllianzAcceptedText').addClass('hide');
                $('#insurance_unavailable').removeClass('hide');
                AllianzError.allianzNotAvailable();
            }else{
                FG.Checkout.prototype.makeStepActive('collapseThree');
                getQuote.call(activePayment);
            }
        }else{
            FG.Checkout.prototype.makeStepActive('collapseThree');
            $('#insuranceAllianzAcceptedText').addClass('hide');
            $('#insurance_unavailable').removeClass('hide');
            AllianzError.allianzNotAvailable();
        } 
      }
    }
  }

  function deriveBookingId(paymentMethod) {
    var transactionId = $('#transactionId').val();

    if (paymentMethod === 'Paypal') {
      transactionId += '_PP';
    }

    if ($("#layaway_fee_span").length > 0) {
      transactionId += '_LA';
    }

    return transactionId;
  }

  return {
    getQuote: getQuote,
    doPurchaseRequestAllianz: doPurchaseRequestAllianz,
    doDecisionRequestAllianz: doDecisionRequestAllianz,
    getBillingCountry: getBillingCountry,
    allowBillingState: allowBillingState,
    renderWithoutAllianz: renderWithoutAllianz,
    promoAllianz:promoAllianz,
  };
})(window, document);


